import {useTranslation} from "react-i18next";
import IconBool from "components/IconBool";
import {useEffect} from "react";
import DateDisplay from "components/datetime/DateDisplay";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableAlertsBridge = (props) => {
    const {t: _Tc} = useTranslation("choices");
    const { t: _Tt } = useTranslation("tables");

    useEffect(() => {
        props.orderingRef.current.setHeaders([
        { name: _Tt("alerts.create_at"), attr: 0, direction: "asc", active: true, default: true },
        { name: _Tt("alerts.resolved"), attr: 1, direction: "asc", active: false },
        { name: _Tt("alerts.type"), attr: 2, direction: "asc", active: false },
        { name: "UID", attr: 3, direction: "asc", active: false },
        { name: "UUID", attr: 4, direction: "asc", active: false },
        { name: _Tt("alerts.municipality"), attr: 5, direction: "asc", active: false },
        { name: _Tt("alerts.province"), attr: 6, direction: "asc", active: false },
        { name: _Tt("alerts.group"), attr: 7, direction: "asc", active: false },
        { name: _Tt("alerts.value"), attr: 8, direction: "asc", active: false },
    ]);
    }, []);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            props.items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            props.items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        props.items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            props.setCheckAll(true);
            props.items.current.chosen = props.itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            props.setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            props.items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...props.buttonsTB};
        buttons.delete.disabled = props.items.current.chosen.length === 0;
        props.setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <>
            <div className="col-12">
                <>
                    <table className="table table-striped table-sticky-horizontal">
                        <thead>
                            <tr>
                                <th key="-1" className="sticky-top border-bottom-sticky" style={{...stickyHeaderStyle}}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="all"
                                        checked={props.checkAll}
                                        onChange={handleCheckAll}
                                    />
                                </th>
                                <OrderByHeaders orderingRef={props.orderingRef} styleHeaders={stickyHeaderStyle} />
                            </tr>
                        </thead>
                        <tbody>
                            {props.itemsShow &&
                                props.itemsShow.map((item) => (
                                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                name="checkboxContainer"
                                                key={item.id}
                                                data-idx={item.id}
                                                defaultChecked={props.items.current.chosen.includes(item.id)}
                                                readOnly={true}
                                            />
                                        </td>
                                        <td>
                                            <DateDisplay date={item.created_at} title={true} />
                                        </td>
                                        <td>
                                            <IconBool value={item.resolved} />
                                        </td>
                                        <td>{_Tc("alerts_types." + item.type)}</td>
                                        <td>{item.asset_uid}</td>
                                        <td>{item.device_uuid}</td>
                                        <td>{item.municipality}</td>
                                        <td>{item.province}</td>
                                        {/* <td>{item.routes}</td> */}
                                        <td>{item.group}</td>
                                        <td>{item.value}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </>
            </div>
        </>
    );
};

export default TableAlertsBridge;
